import React, {useEffect, useState} from 'react'
import './Faq.scss'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons/faQuestionCircle'

const Faq = ({question, answer}) => {
    const [isOpen, setIsOpen] = useState(true)
    useEffect(() => {
        setIsOpen(false)
    }, [])

    const toggleOpen = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen)
    }

    return (
        <div
            className="faq"
            onClick={toggleOpen}
            role="button"
            tabIndex={0}
            onKeyDown={toggleOpen}
            style={{outline: 'none'}}
        >
            <div className="faq__question">
                <FontAwesomeIcon icon={faQuestionCircle} className={'faq__question-icon'} />
                <h3 className="is-size-4 is-size-6-mobile has-text-weight-normal is-marginless">{question}</h3>
            </div>
            <div style={{display: isOpen ? 'block' : 'none'}}>
                <ReactMarkdown source={answer} className="faq__answer" />
            </div>
        </div>
    )
}

Faq.propTypes = {
    question: PropTypes.string,
    answer: PropTypes.string,
}

Faq.defaultProps = {
    question: '',
    answer: '',
}

export default Faq
